module.exports = __webpack_public_path__ + "img/yanwu.d5849610.jpg";